import { ValueDecoder } from '@cp/common/routing/lib';
import { useMemo } from 'react';
import { useRouter } from '../router';
import { QueryParamsDictionary } from './model';
import { getQueryParams } from './getQueryParams';

export const useGetQueryParams = <T extends QueryParamsDictionary = QueryParamsDictionary>(
  defaultParams?: T | null,
  opts?: { decoder?: ValueDecoder },
): T => {
  const router = useRouter();
  return useMemo(() => getQueryParams(router, defaultParams || undefined, opts), [defaultParams, opts, router.location.search]);
};
